<template>
  <div class="cost-summary">
    <div class="text-highlight mr-3">
      <div v-if="showFee">Base Price:</div>
      <div v-if="showFee">Fee:</div>
      <div>Total:</div>
    </div>
    <div>
      <div v-if="showFee">
        {{registration.cost.calc_amount | currency}}<span v-if="isWaitlist" class="invisible">*</span>
      </div>
      <div v-if="showFee">
        {{registration.cost.calc_amount_fees | currency}}<span v-if="isWaitlist" class="invisible">*</span>
      </div>
      <div>
        {{registration.cost.amount_to_charge | currency}}<span v-if="isWaitlist">*</span>
      </div>
    </div>
  </div>
</template>

<script>
import AppMixin from '../services/mixin.app';

export default {
  name: 'cost-summary',
  props: ['registration'],
  mixins: [AppMixin],
  computed: {
    showFee() {
      return !this.registration.pricing_package.price_fees_included;
    },
    isWaitlist() {
      return this.registration.state === 'waitlist';
    },
  },
};
</script>
